<template>
  <div class="help flex-column">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('help') }}</span>
      </div>
    </div>
    <HelpComponent />
  </div>
</template>

<script>
import HelpComponent from '@/components/HelpComponent.vue';

export default {
  name: 'Help',
  components: { HelpComponent },
  data() {
    return {
      programName: '',
    };
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.help {
  width: 100%;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: $primary-white;
  .title {
    font-size: 32px;
    line-height: 38px;
    font-weight: bold;
    text-transform: uppercase;
  }
}
.content {
  padding: 30px;
  color: #1d1d1b;
  text-align: left;
  font-size: 16px;
  .link {
    color: #243882;
  }
}
</style>
